import CONFIG from "../appconfig.json";
import axios from "axios";
import { GetAuthorisationHeaderGroup } from "./assetxphelpers";

export const productsearchstate = {
  namespaced: true,
  state: {
    reindexing: false,
    error: null,
    lastReindexCount: null,

    searching: false,
    searchError: null,
    searchResults: [],
    searchTotalCount: 0,

    statsLoading: false,
    statsError: null,
    indexStats: null,
  },
  mutations: {
    SetReindexing(state, reindexing) {
      state.reindexing = reindexing;
    },
    SetError(state, error) {
      state.error = error;
    },
    SetLastReindexCount(state, count) {
      state.lastReindexCount = count;
    },
    SetSearching(state, searching) {
      state.searching = searching;
    },
    SetSearchError(state, error) {
      state.searchError = error;
    },
    SetSearchResults(state, { results, totalCount }) {
      state.searchResults = results || [];
      state.searchTotalCount = totalCount || 0;
    },
    ClearSearchResults(state) {
      state.searchResults = [];
      state.searchTotalCount = 0;
      state.searchError = null;
    },
    SetStatsLoading(state, loading) {
      state.statsLoading = loading;
    },
    SetStatsError(state, error) {
      state.statsError = error;
    },
    SetIndexStats(state, stats) {
      state.indexStats = stats;
    },
  },
  actions: {
    async ReindexProducts({ commit, dispatch }) {
      commit("SetReindexing", true);
      commit("SetError", null);

      try {
        const response = await axios.post(
          CONFIG.platformEndpoints.assetxpapi + "product-search/reindex",
          {},
          GetAuthorisationHeaderGroup()
        );
        const count = response.data && typeof response.data.count === "number" ? response.data.count : null;
        commit("SetLastReindexCount", count);

        // Best-effort refresh so the stats tiles reflect the reindex immediately. A failure here
        // shouldn't mask the reindex's own success, so it's deliberately not awaited-and-rethrown.
        dispatch("GetIndexStats").catch(() => {});

        return response.data;
      } catch (error) {
        commit("SetError", "Failed to rebuild the product search index.");
        throw error;
      } finally {
        commit("SetReindexing", false);
      }
    },

    async SearchProducts({ commit }, { query, page, pageSize }) {
      commit("SetSearching", true);
      commit("SetSearchError", null);

      try {
        const response = await axios.post(
          CONFIG.platformEndpoints.assetxpapi + "product-search/search",
          { query, page, pageSize },
          GetAuthorisationHeaderGroup()
        );
        commit("SetSearchResults", {
          results: response.data && response.data.results,
          totalCount: response.data && response.data.totalCount,
        });
        return response.data;
      } catch (error) {
        commit("SetSearchError", "Product search failed. It may be temporarily unavailable - try again.");
        throw error;
      } finally {
        commit("SetSearching", false);
      }
    },

    async GetIndexStats({ commit }) {
      commit("SetStatsLoading", true);
      commit("SetStatsError", null);

      try {
        const response = await axios.get(
          CONFIG.platformEndpoints.assetxpapi + "product-search/stats",
          GetAuthorisationHeaderGroup()
        );
        commit("SetIndexStats", response.data);
        return response.data;
      } catch (error) {
        commit("SetStatsError", "Failed to load index stats.");
        throw error;
      } finally {
        commit("SetStatsLoading", false);
      }
    },
  },
};
